
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as frontd7WyV2_45m2454fUIQQbrDkjMd0W39pBFOKhwlpJieE3gMeta } from "/home/runner/work/cpp/cpp/pages/front.vue?macro=true";
import { default as indexru4eE13DCE08pYNynIF_dZsxzf39pSIdpEEDlhCYdWYMeta } from "/home/runner/work/cpp/cpp/pages/index.vue?macro=true";
import { default as latestUk2DZEG4As4MWdlVMdgmQHf3eJ8WxjpH290blVjRcVUMeta } from "/home/runner/work/cpp/cpp/pages/latest.vue?macro=true";
import { default as searchrZFy1xCaeyGmn7IH3m7nw_eMQ7BEhaldKsDzjj6XtXAMeta } from "/home/runner/work/cpp/cpp/pages/search.vue?macro=true";
import { default as staticsIte75uMlI_yR95JyjAnxPeHOHHPEKc12D8y8Gd_45fkkMeta } from "/home/runner/work/cpp/cpp/pages/static.vue?macro=true";
import { default as article82tJ4CzsSAsatFLZrjExcgLgaVBO4b2KcOylx_bE3skMeta } from "/home/runner/work/cpp/cpp/pages/article.vue?macro=true";
import { default as _91section_93Wejvogpw9ZwEkBUaUHDyTetYN5oFl3_45T9_45kJSJeYaDQMeta } from "/home/runner/work/cpp/cpp/pages/[section].vue?macro=true";
import { default as _91tag_93dyWkctgq8W4cpnRNt6GoDajJB7ZwnmcTD6feudpqwGcMeta } from "/home/runner/work/cpp/cpp/pages/tag/[tag].vue?macro=true";
import { default as _91topic_933rvfgVfLzF7ySp4UO2ajvlfNFGrErYu4WFvoQmYJ1l4Meta } from "/home/runner/work/cpp/cpp/pages/topic/[topic].vue?macro=true";
import { default as previewh5j1biZCjfbDxOZPUFkxst_H6o3klAgO6FAx95Ye_4IMeta } from "/home/runner/work/cpp/cpp/pages/edition/preview.vue?macro=true";
export default [
  {
    name: "front___en",
    path: "/front",
    component: () => import("/home/runner/work/cpp/cpp/pages/front.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: indexru4eE13DCE08pYNynIF_dZsxzf39pSIdpEEDlhCYdWYMeta || {},
    alias: ["/d2","/magasinet"],
    component: () => import("/home/runner/work/cpp/cpp/pages/index.vue")
  },
  {
    name: "latest___en",
    path: "/latest",
    meta: latestUk2DZEG4As4MWdlVMdgmQHf3eJ8WxjpH290blVjRcVUMeta || {},
    alias: ["/siste"],
    component: () => import("/home/runner/work/cpp/cpp/pages/latest.vue")
  },
  {
    name: "search___en",
    path: "/search",
    meta: searchrZFy1xCaeyGmn7IH3m7nw_eMQ7BEhaldKsDzjj6XtXAMeta || {},
    alias: ["/archive","/sok","/arkiv"],
    component: () => import("/home/runner/work/cpp/cpp/pages/search.vue")
  },
  {
    name: "static___en",
    path: "/static",
    meta: staticsIte75uMlI_yR95JyjAnxPeHOHHPEKc12D8y8Gd_45fkkMeta || {},
    alias: ["/contactus","/hjelp","/aboutus","/terms","/kontaktoss","/help","/omoss","/vilkar"],
    component: () => import("/home/runner/work/cpp/cpp/pages/static.vue")
  },
  {
    name: "article___en",
    path: "/:pathMatch(.*)?/:lcsId([0-9]\\-[0-9]\\-[0-9]+|[0-9]-[0-9]-[0-9]+PT[0-9]+)",
    meta: article82tJ4CzsSAsatFLZrjExcgLgaVBO4b2KcOylx_bE3skMeta || {},
    component: () => import("/home/runner/work/cpp/cpp/pages/article.vue")
  },
  {
    name: "section___en",
    path: "/:section([A-Za-zæøåÆØÅ&_%C3%A6%C3%B8%C3%A5%C3%86%C3%98%C3%85]+$)",
    meta: _91section_93Wejvogpw9ZwEkBUaUHDyTetYN5oFl3_45T9_45kJSJeYaDQMeta || {},
    component: () => import("/home/runner/work/cpp/cpp/pages/[section].vue")
  },
  {
    name: "tag-tag___en",
    path: "/tag/:tag()",
    component: () => import("/home/runner/work/cpp/cpp/pages/tag/[tag].vue")
  },
  {
    name: "topic-topic___en",
    path: "/topic/:topic()",
    meta: _91topic_933rvfgVfLzF7ySp4UO2ajvlfNFGrErYu4WFvoQmYJ1l4Meta || {},
    component: () => import("/home/runner/work/cpp/cpp/pages/topic/[topic].vue")
  },
  {
    name: "edition-preview___en",
    path: "/edition/preview",
    meta: previewh5j1biZCjfbDxOZPUFkxst_H6o3klAgO6FAx95Ye_4IMeta || {},
    alias: ["/d2/edition/preview","/magasinet/edition/preview"],
    component: () => import("/home/runner/work/cpp/cpp/pages/edition/preview.vue")
  }
]